__turbopack_context__.v({
  "showtime-list": "showtime-list-module-scss-module__uJ7szG__showtime-list",
});
